import type { DynamicFieldData, FieldTypes } from '@restore/dynamic-forms';

export const getDateFields = (fields: DynamicFieldData<FieldTypes>[]) => {
  const dateFields = fields.filter((field) => {
    return field.inputType === 'control_datetime';
  });

  return dateFields.map((field) => {
    return field.fieldName;
  });
};
